import { createFileRoute } from "@tanstack/react-router";

import { FillScreen, HStack, Spacer, VStack } from "@/components/Layout";
import { MediumCategoryCard } from "@/features/operation-package-instance-profile-data/-components/MediumCategoryCard";
import { ProfileAttributeValueProvider } from "@/features/operation-package-instance-profile-data/-components/ProfileAttributeValueProvider";
import { SideNavigation } from "@/features/operation-package-instance-profile-data/-components/SideNavigation";

import { useQueryOperationPackageInstanceData } from "../-queries/useQueryOperationPackageInstanceData";

export const Route = createFileRoute(
  "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { instanceId } = Route.useParams();
  const { data } = useQueryOperationPackageInstanceData(instanceId);

  if (!data) return null;

  return (
    <ProfileAttributeValueProvider data={data}>
      <FillScreen>
        <HStack className="px-12 py-6 gap-9">
          <SideNavigation data={data} />
          <VStack className="gap-12 flex-1">
            {/* すべての大分類と中分類を表示 */}
            {data.map((largeCategory) => (
              <VStack
                key={largeCategory.largeCategoryCode}
                className="gap-8 w-full"
                id={largeCategory.largeCategoryCode}
              >
                {/* 中分類カード */}
                {largeCategory.mediumCategoryData.map((mediumCategory) => (
                  <MediumCategoryCard
                    key={mediumCategory.mediumCategoryCode}
                    data={mediumCategory}
                  />
                ))}
              </VStack>
            ))}
            <Spacer size={24} />
          </VStack>
        </HStack>
      </FillScreen>
    </ProfileAttributeValueProvider>
  );
}
